import { Pipe, PipeTransform } from '@angular/core';
import { SensorDetailDto } from '@artemis-software/wr-api';
import SensorPurposeEnum = SensorDetailDto.PurposeEnum;

@Pipe({
  standalone: false,
  name: 'sensorPurpose'
})
export class SensorPurposePipe implements PipeTransform {
  transform(value: SensorPurposeEnum | undefined | null): string {
    switch (value) {
      case SensorPurposeEnum.RootMeter:
        return 'Wurzelzähler';
      case SensorPurposeEnum.UnitMeter:
        return 'Wohnungszähler';
      case SensorPurposeEnum.Monitoring:
        return 'Anlagenstatus';
    }
    return 'k.A.';
  }
}
